import styled from "styled-components";
import { Box } from "rebass/styled-components";
import { ClipVideoCard } from "../../../MVVM/Components/Clip";
import {
  getDisplayName,
  getClipTitle,
  getSnapshotPath,
  formatNumber,
} from "../../molecules/clip/utils";
import { clipHasStudio } from "../../../utils";
import { getAvatarImage } from "../../../MVVM/Utilities/User";
import { TbPinnedFilled, TbChevronsDown } from "react-icons/tb";
import { Body } from "../../text";
import { MatchHistoryWidget } from "MVVM/Views/MatchHistory/MatchHistoryWidget";
import { EClipsViews } from "MVVM/@types";

const CardGrid = (props) => {
  if (props.clips.length === 0) {
    return null;
  }
  const clips = props.clips.filter((clip) => {
    return !!clip.user;
  });

  const displayMatchHistoryWidget =
    props.isOwnProfile &&
    [EClipsViews.Clips, EClipsViews.Montages].includes(props.view);
  return (
    <ClipGrid singleRow={props.singleRow}>
      {clips.map(function (clip, index) {
        const owner = getDisplayName(clip);
        const avatar = getAvatarImage(clip.user);
        const to = props.isMontage
          ? `/montage?montage=${clip.shareId}`
          : `/clip?clip=${clip.shareId}`;
        let previewImage;
        if (!props.localFile) {
          previewImage = getSnapshotPath(clip.clipImageThumb);
        } else {
          previewImage = clip.clipImageThumb;
        }

        return (
          <>
            {index === 0 && displayMatchHistoryWidget && <MatchHistoryWidget />}
            <ClipVideoCard
              key={index}
              index={index}
              snapshot={previewImage}
              shareId={clip.shareId}
              to={to}
              description={{
                title: clip.userClipTitle
                  ? clip.userClipTitle
                  : getClipTitle(clip),
                date: clip.createdDate,
                views: clip.views ? formatNumber(clip.views) : 0,
              }}
              avatar={avatar}
              displayName={owner}
              ownerId={clip.user._id}
              user={clip.user}
              status={clip.status}
              modifiable={props.modifiable}
              duration={clip.clipLength + " sec"}
              clipId={clip._id}
              id={clip._id}
              clipGame={clip.game}
              removeClip={props.removeClip}
              singleRow={props.singleRow}
              isFeed={props.isFeed}
              hasStudio={clipHasStudio(clip)}
              isOwnClip={clip.user._id === props?.allstarUser?.user?._id}
              clip={clip}
              mutateReaction={props.mutateReaction}
              followUnfollow={props.followUnfollow}
              allstarUser={props.allstarUser}
              setFollowModal={props.setFollowModal}
              setClipInactive={props.setClipInactive}
              isProfile={props.isProfile}
              localFile={props.localFile}
              isMontage={props.isMontage}
              game={props.game}
              autoplay={props.autoplay}
              hideBigPlay={true}
              isOwnProfile={props.isOwnProfile}
            />
          </>
        );
      })}
    </ClipGrid>
  );
};

CardGrid.defaultProps = {
  singleRow: false,
  feed: false,
};

export default CardGrid;

const ClipGrid = styled(Box)`
  display: grid;
  margin: auto;
  width: 100% !important;
  grid-row-gap: ${(props) => (props.singleRow ? 0 : props.theme.space[7])}px;
  ${(props) =>
    props.singleRow
      ? {
          "grid-template-rows": "auto 0 0 0",
        }
      : null}

  ${(props) => `
  ${
    !props.singleRow
      ? false
      : `
    grid-column-gap: ${props.theme.space[7]}px;
    grid-template-columns: repeat(3, 1fr);

    @media
    (min-width: ${
      props.theme.sizes[4] * 3 +
      props.theme.space[7] * 2 +
      props.theme.space[8] * 2 +
      1
    }px)
    {
      grid-template-columns: repeat(4, 1fr);
    }

    @media
    (max-width: ${
      props.theme.sizes[2] * 3 +
      props.theme.space[7] * 2 +
      props.theme.space[8] * 2 +
      1
    }px)
    {
    max-width: ${props.theme.sizes[4] * 2 + props.theme.space[7] * 1}px;
      grid-template-columns: repeat(2, 1fr);
    }
    @media
    (max-width: ${
      props.theme.sizes[2] * 2 +
      props.theme.space[7] +
      props.theme.space[8] * 2 +
      1
    }px)
    {
    max-width: ${props.theme.sizes[4]}px;
    grid-template-columns: repeat(1, 1fr);
  }
  `
  }
  `}
`;

const StyledFilledPinnedIcon = styled(TbPinnedFilled)`
  margin-right: 3px;
  color: ${({ theme }) => theme.colors.error};
`;
const StyledBodyText = styled(Body)`
  font-weight: 500;
`;

const StyledDoubleChevronDown = styled(TbChevronsDown)`
  color: ${({ theme }) => theme.colors.chalk};
`;
